import * as React from "react";

const SvgHeavySleetThunderSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__a">
        <path d="M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__b">
        <path d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__c">
        <path d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__d">
        <path
          d="M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__e">
        <path
          d="m895.908 219.964-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__f">
        <path d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetThunderSun_svg__g">
        <path d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733" />
      </clipPath>
    </defs>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 960 -86.15)"
      d="M-720 64.612h72v72h-72z"
    />
    <g
      clipPath="url(#HeavySleetThunderSun_svg__a)"
      style={{
        fill: "#ffc724",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.198 765.869)"
    >
      <g
        style={{
          fill: "#ffc724",
          fillOpacity: 1,
        }}
      >
        <path
          d="M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
          style={{
            fill: "#ffc724",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetThunderSun_svg__b)"
      transform="matrix(1.33333 0 0 -1.33333 -1772.028 979.657)"
      style={{
        fill: "#d2e9f8",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#d2e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
          style={{
            fill: "#d2e9f8",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetThunderSun_svg__c)"
      transform="matrix(1.33333 0 0 -1.33333 -350.877 762.903)"
      style={{
        fill: "#fec524",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#fec524",
          fillOpacity: 1,
        }}
      >
        <path
          d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
          style={{
            fill: "#fec524",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      style={{
        fill: "#647179",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.005-.253.005-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
        style={{
          fill: "#647179",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
        transform="matrix(1.33333 0 0 -1.33333 65.92 64.171)"
      />
    </g>
    <g
      style={{
        fill: "#d2e9f8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1171.947 368.585)"
      clipPath="url(#HeavySleetThunderSun_svg__d)"
    >
      <g
        style={{
          fill: "#d2e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            fill: "#d2e9f8",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1158.735 371.442)"
      clipPath="url(#HeavySleetThunderSun_svg__e)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m895.908 219.964-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetThunderSun_svg__f)"
      transform="matrix(1.33333 0 0 -1.33333 -1787.028 979.657)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetThunderSun_svg__g)"
      transform="matrix(1.33333 0 0 -1.33333 -1723.028 979.657)"
      style={{
        fill: "#d2e9f8",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#d2e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
          style={{
            fill: "#d2e9f8",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgHeavySleetThunderSun;
